import React from 'react';

import ParameterItem from '@components/Map/SitesInfo/SiteParameters/ParameterItem';

import { TCellsData } from '@interfaces/cells/cells';
import { ISiteProfile } from '@interfaces/cells/siteProfile';

import styles from '@components/Map/SitesInfo/SiteParameters/SiteParameters.module.scss';

interface IMultiSiteParametersProps {
	sites: Array<ISiteProfile>;
	cells: TCellsData[];
}

const MultiSiteParameters = ({ sites, cells }: IMultiSiteParametersProps) => {
	return (
		<div className={styles.multiSiteInfoContainer}>
			<ParameterItem
				label='Total sites'
				value={sites.length}
			/>
			<ParameterItem
				label='Cells'
				value={cells.reduce((acc, cell) => acc + cell.count, 0)}
			/>
		</div>
	);
};

export default MultiSiteParameters;
